import events from "./events";
import { AppConfig } from "../types";
import { formatEvents } from "../formatEvents";

export default formatEvents(events) as AppConfig;
